import 'jquery-resizable-columns';
import 'dragtable';
import 'bootstrap-table';
// import 'bootstrap-table/src/extensions/resizable/bootstrap-table-resizable'; // broken?
import 'bootstrap-table/src/extensions/fixed-columns/bootstrap-table-fixed-columns';
import 'bootstrap-table/src/extensions/multiple-sort/bootstrap-table-multiple-sort';
import 'bootstrap-table/src/extensions/filter-control/bootstrap-table-filter-control';
import 'bootstrap-table/src/extensions/sticky-header/bootstrap-table-sticky-header';
import 'bootstrap-table/src/extensions/reorder-columns/bootstrap-table-reorder-columns';
import '../app/common/natural-sorting';
